export default __webpack_public_path__ + "static/ntu-d36126005477d664e148dc102fc59682.png";